import React from 'react'
import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridItemChangeEvent,
    GridPageChangeEvent,
    GridPagerSettings,
    GridRowProps,
    GridNoRecords
  } from "@progress/kendo-react-grid";
import { useState } from "react";
import { orderBy, SortDescriptor } from "@progress/kendo-data-query";
import { Icon } from '@iconify/react';

function ActivePositions(props: any) {
  const initialSort: Array<SortDescriptor> = [
    { field: "priority", dir: "asc" },
  ];

  const [sort, setSort] = useState(initialSort);

  const openInNewTab = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  
  const companyCell = (props: GridCellProps) => {
  
    const companySettingsRedirection = (data: any) => {
      data.companyType = 1;
      localStorage.setItem('CompanySettings', JSON.stringify(data))
      openInNewTab(`${window.location.origin}/companysettings`)

  }

    return (
      <td onClick={() => companySettingsRedirection(props.dataItem)}>
        {props.dataItem.company}
      </td>
    )
}


  return (
      <Grid
      data={props.data}
      sortable={true}
      sort={sort}
      onSortChange={(e) => {
        setSort(e.sort);
        props.setSort(e.sort);
        props.applySort(e.sort);
      }}
      >

      <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
          
      <Column field="positionName" title="Role" />
      <Column field="company" title="Company" cell={companyCell}/>
      <Column field="positionCount" title="Positions" />
          
    </Grid>
  )
}

export default ActivePositions